import { HelpIcon } from '@dixa/lib-shared-habla';

import Spinner from '../../ajax/components/Spinner';
import Switch from '../switch/Switch';

import './styles/dixa-switch.less';

type PropsT = {
  id?: string;
  name?: string;
  displayName: string;
  disabled: boolean | null;
  hidden: string | null;
  required?: boolean;
  input: any;
  meta: any;
  showSpinner?: boolean;
  className: string | null;
  labelA?: string;
  labelB?: string;
  isChecked: boolean;
  showHelpIcon: boolean | null;
  helpIconTitle: string;
  helpIconText: string;
  onChangeAction: ((e: any) => void) | null;
  onBlurAction: ((e: any) => void) | null;
  controlled: boolean; // See https://reactjs.org/docs/uncontrolled-components.html
};

const DixaSwitch = ({
  name,
  displayName,
  hidden,
  disabled,
  input,
  meta,
  showSpinner,
  className,
  isChecked,
  showHelpIcon,
  helpIconTitle,
  helpIconText,
  labelA,
  labelB,
  onChangeAction,
  onBlurAction,
  controlled,
}: PropsT) => {
  let formGroupClasses =
    className && typeof className === 'string' ? className : '';
  let validationErrors: JSX.Element | null = null;
  let spinner: JSX.Element | null = null;
  let helpIcon: JSX.Element | null = null;
  let checked = false;

  if (controlled) {
    checked = typeof isChecked === 'boolean' ? isChecked : input.value;
  } else {
    checked = input.value === '' ? isChecked : input.value;
  }

  if (meta !== undefined && meta.touched === true && meta.valid === true) {
    formGroupClasses += ' has-success';
  } else if (meta !== undefined && meta.touched === true && meta.error) {
    formGroupClasses += ' has-error';
    validationErrors = <span className="validation-text">{meta.error}</span>;
  }

  if (hidden) {
    formGroupClasses += ' hidden';
  }

  if (disabled) {
    formGroupClasses += ' disabled';
  }

  if (showSpinner) {
    spinner = <Spinner className="dark input" />;
  }

  if (showHelpIcon) {
    helpIcon = (
      <div className="helpIcon">
        <HelpIcon text={helpIconText} title={helpIconTitle} />
      </div>
    );
  }
  input.value === '' ? isChecked : input.value;

  return (
    <div className={'form-group dixa-switch ' + formGroupClasses}>
      <label className="control-label pull-left" htmlFor={name}>
        {displayName} {validationErrors}
      </label>
      <div className="pull-right onselect">
        <Switch
          id={name}
          value={input.value as any}
          onBlur={(e: any) => {
            if (typeof onBlurAction === 'function') {
              onBlurAction(e);
            }
            input.onBlur(e);
          }}
          onFocus={(e: any) => {
            input.onFocus(e);
          }}
          disabled={disabled as any}
          onChange={
            ((e: any) => {
              if (typeof onChangeAction === 'function') {
                onChangeAction(e);
              }
              input.onChange(e);
            }) as any
          }
          checked={checked}
          labelA={labelA}
          labelB={labelB}
        />
        {spinner}
      </div>
      {helpIcon}
    </div>
  );
};

DixaSwitch.defaultProps = {
  controlled: false, // https://reactjs.org/docs/uncontrolled-components.html
};

export default DixaSwitch;
